(function (Drupal, $, once) {
  Drupal.behaviors.fcp = {
    attach: function (context) {
      $(function () {
        $(once('flexible-content-once', ".page-node-type-flexible-content, .page-node-type-landing-page, .page-node-type-news, .page-node-type-research"))
          .each(function () {
            if ($(".paragraph-related-content__wrapper").length) {
              $(".paragraph-related-content__wrapper")
                .insertAfter(".main-content__wrapper")
                .show();
            }
          });

        $(once('sidebar-menu-flexible-content-once', ".sidebar-menu"))
          .each(function () {
            if (
              !$(this).find(".main-menu__link.main-menu__link--active").length
            ) {
              $(this).children("h2").addClass("active");
            }
          });

        //Eligibility checker
        if ($("#block-eligibilitychecker").length) {
          $("body").addClass("eligibility-checker");

          if ($("#edit-starting-markup").length) {
            setTimeout(() => {
              $("html, body").stop().animate({
                scrollTop: 0,
              });
            }, 500);
          }

          $(document).ajaxComplete(function () {
            $(document).on('click', '.webform-help-popup a', function(e) {
              e.preventDefault();
              var url = $(this).attr('href');
              window.open(url, '_blank');
            })
            //build progress bar
            var progressBar = $(".webform-progress__percentage");
            var progress = progressBar
              .text()
              .substr(0, 1 + progressBar.text().indexOf("%"));

            //make it so 'Restart' reloads the page
            $('[id^="edit-actions-wizard-prev"]').attr(
              "onclick",
              "location.reload()"
            );
            $(once("progress-ready", ".webform-progress__status"))
              .each(function () {
                $(this).append(
                  `<div class="progress-container"><div class="progress-bar"></div></div>`
                );
                setTimeout(() => {
                  $(this).find(".progress-bar").css("width", progress);
                }, 100);
              });

            //Show/hide progress bar
            if (
              $("[id^='edit-starting-markup']").length ||
              $("[id^='edit-eligibility-screen']").length
            ) {
              $("#block-eligibilitychecker").removeClass("has-progress");
            } else {
              $("#block-eligibilitychecker").addClass("has-progress");
            }
            if ($("[id^='edit-eligibility-screen']").length) {
              $("#block-eligibilitychecker").addClass("full");
            } else {
              $("#block-eligibilitychecker").removeClass("full");
            }

            $(".radios--wrapper").on("change", function () {
              $('[id^="edit-actions-wizard-next"]').addClass("ready");
            });
          });

          //make it so 'Restart' reloads the page
          $('[id^="edit-actions-wizard-prev"]').attr(
            "onclick",
            "location.reload()"
          );

          //Show/hide help popup
          $(once('help-popup-webform', ".webform-element-help"))
            .click(function () {
              var popupContent = $(this).attr("data-webform-help");
              if (!$(this).find(".webform-help-popup").length) {
                $(this).append(
                  `<div class="popup-bg"></div><div class="webform-help-popup"><div class="webform-help-popup__content"><button type="button" title="close popu"></button>${popupContent}</div></div>`
                );
              }
              $(this).addClass("open").find(".webform-help-popup").fadeIn(300);
            });

          $(document).mouseup(function (e) {
            var container = $(".webform-help-popup");
            if (
              !container.is(e.target) &&
              container.find(e.target).length === 0
            ) {
              container.fadeOut(300);
              container.closest(".webform-element-help").removeClass("open");
            }
          });

          $(document).on("click", ".webform-help-popup button", function () {
            $(this).closest(".webform-help-popup").fadeOut(300);
            $(this).closest(".webform-element-help").removeClass("open");
          });
        }

        //Regional checker
        $(once('regional-checker-once', "#block-checkerblock #checker-form"))
          .each(function () {
            var firstFieldFilled;
            var secondFieldFilled;
            $("body").addClass("regional-checker");

            //Search autocomplete
            $(once('autocomplete-once', "#block-checkerblock input[type=text]"))
              .on("keyup", function () {
                var form = $(this).closest("form");
                var search = $(this).parent(".js-form-type-textfield");
                var val = $(this).val();

                if (search.hasClass("js-form-item-suburb")) {
                  firstFieldFilled = false;
                } else {
                  secondFieldFilled = false;
                }

                checkForm();

                //Add close
                if (val.length > 0) {
                  if (!search.children(".search-clear").length) {
                    search.append(
                      '</div><button class="search-clear" type="button" title="Clear the search"><span></span></button>'
                    );
                  }
                  if (!search.children(".autocomplete-wrapper").length) {
                    search.append('<div class="autocomplete-wrapper"></div>');
                  }
                } else {
                  search.children(".search-clear").remove();
                }

                //Autocomlete
                if (val.length > 0) {
                  $.ajax("/region-autocompletion-callback?combine=" + val, {
                    success: function (data) {
                      updateAutoComplete(data, val, search);
                    },
                  }).done(function (data) {
                    updateAutoComplete(data, val, search);
                  });
                } else {
                  search.children(".autocomplete-wrapper").children().remove();
                }
              });

            //autocomplete function
            var updateAutoComplete = function (response, val, search) {
              var results = response.slice(0, 25);
              console.log(results.length);
              search.children(".autocomplete-wrapper").children().remove();
              if (results.length) {
                $(results).each(function () {
                  var title = $(this)[0].field_location;
                  search
                    .find(".autocomplete-wrapper")
                    .append(
                      `<div class="autocomplete-option" data-val="${title}">${title}</div>`
                    );
                });
              } else {
                search
                  .find(".autocomplete-wrapper")
                  .append(
                    `<div class="autocomplete-option error">This suburb is not in an eligible regional area.</div>`
                  );
              }
            };

            //Select autocomplete option
            $(document).on(
              "click",
              "#block-checkerblock .autocomplete-option",
              function () {
                var text = $(this).text();
                var search = $(this)
                  .closest(".js-form-type-textfield")
                  .find("input[type=text]");

                if (
                  $(this)
                    .closest(".js-form-type-textfield")
                    .hasClass("js-form-item-suburb")
                ) {
                  firstFieldFilled = true;
                } else {
                  secondFieldFilled = true;
                }

                search.val(text);
                search.focus();
                $(this).parent().children().remove();

                checkForm();
              }
            );

            //close autocomplete dropdown
            $(document).mouseup(function (e) {
              var container = $("#block-checkerblock .autocomplete-wrapper");
              if (
                !container.is(e.target) &&
                container.find(e.target).length === 0
              ) {
                container.children().remove();

                if (!firstFieldFilled) {
                  $(".js-form-item-suburb .form-item__textfield").val("");
                  $(".js-form-item-suburb .search-clear").remove();
                }

                if (!secondFieldFilled) {
                  $(
                    ".js-form-item-suburb-you-want-to-buy-in .form-item__textfield"
                  ).val("");
                  $(
                    ".js-form-item-suburb-you-want-to-buy-in .search-clear"
                  ).remove();
                }
              }
            });

            //Check if the form is filled
            var checkForm = function () {
              if (firstFieldFilled && secondFieldFilled) {
                $(".form-submit").addClass("ready");
              } else {
                $(".form-submit").removeClass("ready");
              }
            };

            //Search close
            $(document).on(
              "click",
              "#block-checkerblock .search-clear",
              function (e) {
                e.preventDefault();

                if (
                  $(this)
                    .closest(".js-form-type-textfield")
                    .hasClass("js-form-item-suburb")
                ) {
                  firstFieldFilled = false;
                } else {
                  secondFieldFilled = false;
                }
                checkForm();

                $(this)
                  .closest(".js-form-type-textfield")
                  .find("input[type=text]")
                  .val("")
                  .focus();
                $(this).remove();
              }
            );

            //Restart checker
            $(document).on(
              "click",
              "#block-checkerblock .restart-checker, #block-checkerblock .restart-checker-button",
              function (e) {
                e.preventDefault();

                firstFieldFilled = false;
                secondFieldFilled = false;
                checkForm();

                $(".region-checker-message").remove();

                $("#block-checkerblock #checker-form .search-clear").remove();
                $("#block-checkerblock #checker-form input[type=text]").val("");
                $("#block-checkerblock #checker-form input[type=text]")
                  .first()
                  .focus();
              }
            );
          });
      });
    },
  };
}(Drupal, jQuery, once));
